import React, { FunctionComponent } from 'react';
import { useClinicSurveysForCheckups } from '../../hooks/useClinicSurveysForCheckups';
import { CheckupRequestInfo } from '@companion-professional/dctypes';
import { QueryLoaderWrapper, ListButtonsContainer } from '@companion-professional/components';
import { SurveyListItem } from './SurveyListItem';
import { Section } from '../../components/Section';

interface SurveysProps {
  checkup: CheckupRequestInfo;
}

// CheckupSurveys is a component that shows a list of surveys that, if all the requested items are uploaded, the user
// can fill out. This is used in the Checkup page.
export const CheckupSurveys: FunctionComponent<SurveysProps> = ({ checkup }) => {
  const { surveys, error, isPending } = useClinicSurveysForCheckups();

  return (
    <>
      <QueryLoaderWrapper isPending={isPending} error={error}>
        {surveys && surveys.length > 0 ? (
          <Section className="py-4" title="Health Surveys">
            <ListButtonsContainer>
              {surveys.map((survey) => (
                <SurveyListItem key={survey.survey_id} survey={survey} checkupRequest={checkup} />
              ))}
            </ListButtonsContainer>
          </Section>
        ) : null}
      </QueryLoaderWrapper>
    </>
  );
};
